import { Box, Typography, useTheme } from "@mui/material";
import React, { Dispatch } from "react";
import { MealPlanDateAssignmentAction } from "../../../MealPlans/Content/Calendar/Form/reducer";
import { MealPlanDateAssignment } from "../../../MealPlans/Content/Calendar/Form/types";
import { useMealPlanCalendarContext } from "../../../MealPlans/contexts/Calendar";
import { GoalDateAssignmentCalendar } from "./GoalConfigurationCalendar";
import { GoalConfigurationDateAssignmentModeForm } from "./GoalConfigurationDateAssignmentModeForm";

interface MealPlanCalendarDateAssignmentProps {
  state: MealPlanDateAssignment;
  warning?: string;
  dispatch: Dispatch<MealPlanDateAssignmentAction>;
}

const MealPlanCalendarDateAssignment = ({ state, warning, dispatch }: MealPlanCalendarDateAssignmentProps) => {
  const {
    palette: { grey },
  } = useTheme();
  const { onChangeDate } = useMealPlanCalendarContext();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", pt: 2 }}>
      {warning && (
        <Box sx={{ display: "flex", justifyContent: "space-around", pb: 5, width: "100%" }}>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "920px",
              minHeight: "51px",
              background: grey[100],
            }}
          >
            {warning}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          height: "100%",
          minWidth: "400px",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <GoalConfigurationDateAssignmentModeForm
            state={state}
            dispatch={dispatch}
            calendarLocation="on left"
            startDateInPastBehavior="error"
          />
        </Box>
        {state.mode === "individual" && (
          <Box sx={{ width: "50%", height: "100%", minWidth: "400px" }}>
            <GoalDateAssignmentCalendar
              state={state}
              dispatch={dispatch}
              onClickCalendarDate={onChangeDate} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MealPlanCalendarDateAssignment;
